function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "#FFF",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.076 1.033h7.815c.216 0 .423.086.576.238l1.968 1.968c.153.153.239.36.239.577V14.89c0 .45-.365.816-.815.816H5.076a.815.815 0 01-.815-.816V1.848c0-.45.365-.815.815-.815z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.228 17.337H3.446a.816.816 0 01-.816-.815V3.478"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.598 18.967H1.815A.815.815 0 011 18.152V5.11"
}));

function SvgDocuments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20
  }, props), _ref);
}

export default SvgDocuments;